// NUCC Health Care Provider Taxonomy codes most relevant to mental /
// behavioral health practices. This is NOT the full code set — it is a
// curated subset covering the disciplines Kindredly's users most often
// bill under. Users may still paste any other NUCC code manually.
//
// Source: https://www.nucc.org/ (Health Care Provider Taxonomy Code Set)

export interface TaxonomyCode {
  code: string;
  label: string;
  category: string;
}

export const TAXONOMY_CODES: TaxonomyCode[] = [
  // --- Group / organization taxonomies ---
  { code: '101YM0800X', label: 'Counselor — Mental Health', category: 'Counselor' },
  { code: '101Y00000X', label: 'Counselor', category: 'Counselor' },
  { code: '101YA0400X', label: 'Counselor — Addiction (Substance Use Disorder)', category: 'Counselor' },
  { code: '101YP2500X', label: 'Counselor — Professional', category: 'Counselor' },
  { code: '101YS0200X', label: 'Counselor — School', category: 'Counselor' },

  // --- Social workers ---
  { code: '1041C0700X', label: 'Clinical Social Worker', category: 'Social Worker' },
  { code: '104100000X', label: 'Social Worker', category: 'Social Worker' },
  { code: '1041S0200X', label: 'Social Worker — School', category: 'Social Worker' },

  // --- Marriage & family therapists ---
  { code: '106H00000X', label: 'Marriage & Family Therapist', category: 'Marriage & Family Therapist' },

  // --- Psychologists ---
  { code: '103T00000X', label: 'Psychologist', category: 'Psychologist' },
  { code: '103TC0700X', label: 'Psychologist — Clinical', category: 'Psychologist' },
  { code: '103TC2200X', label: 'Psychologist — Clinical Child & Adolescent', category: 'Psychologist' },
  { code: '103TF0000X', label: 'Psychologist — Family', category: 'Psychologist' },
  { code: '103TH0100X', label: 'Psychologist — Health', category: 'Psychologist' },
  { code: '103TP2701X', label: 'Psychologist — Group', category: 'Psychologist' },
  { code: '103TP0016X', label: 'Psychologist — Prescribing (Medical)', category: 'Psychologist' },
  { code: '103TR0400X', label: 'Psychologist — Rehabilitation', category: 'Psychologist' },

  // --- Psychiatrists / physicians ---
  { code: '2084P0800X', label: 'Psychiatry & Neurology — Psychiatry', category: 'Psychiatrist' },
  { code: '2084P0804X', label: 'Psychiatry & Neurology — Child & Adolescent Psychiatry', category: 'Psychiatrist' },
  { code: '2084P0805X', label: 'Psychiatry & Neurology — Geriatric Psychiatry', category: 'Psychiatrist' },
  { code: '2084P0802X', label: 'Psychiatry & Neurology — Addiction Psychiatry', category: 'Psychiatrist' },
  { code: '2084P0801X', label: 'Psychiatry & Neurology — Forensic Psychiatry', category: 'Psychiatrist' },

  // --- Psychiatric nurse practitioners ---
  { code: '364SP0807X', label: 'Clinical Nurse Specialist — Psychiatric/Mental Health', category: 'Nurse' },
  { code: '364SP0808X', label: 'Clinical Nurse Specialist — Psychiatric/Mental Health, Child & Adolescent', category: 'Nurse' },
  { code: '364SP0809X', label: 'Clinical Nurse Specialist — Psychiatric/Mental Health, Adult', category: 'Nurse' },
  { code: '364SP0810X', label: 'Clinical Nurse Specialist — Psychiatric/Mental Health, Family', category: 'Nurse' },
  { code: '364SP0811X', label: 'Clinical Nurse Specialist — Psychiatric/Mental Health, Chronically Ill', category: 'Nurse' },
  { code: '364SP0812X', label: 'Clinical Nurse Specialist — Psychiatric/Mental Health, Community', category: 'Nurse' },
  { code: '363LP0808X', label: 'Nurse Practitioner — Psychiatric/Mental Health', category: 'Nurse' },

  // --- Physician assistants ---
  { code: '363AM0700X', label: 'Physician Assistant — Medical', category: 'Physician Assistant' },

  // --- Behavior analysts ---
  { code: '103K00000X', label: 'Behavioral Analyst', category: 'Behavior Analyst' },
  { code: '106S00000X', label: 'Behavior Technician', category: 'Behavior Analyst' },

  // --- Addiction treatment ---
  { code: '324500000X', label: 'Substance Abuse Rehabilitation Facility', category: 'Facility' },
  { code: '261QM0801X', label: 'Clinic/Center — Mental Health (Including Community Mental Health Center)', category: 'Facility' },
  { code: '261QM0855X', label: 'Clinic/Center — Adolescent and Children Mental Health', category: 'Facility' },
  { code: '261QM2800X', label: 'Clinic/Center — Methadone', category: 'Facility' },
  { code: '261QR0405X', label: 'Clinic/Center — Rehabilitation, Substance Use Disorder', category: 'Facility' },

  // --- Art / music / play therapy ---
  { code: '225XR0403X', label: 'Recreational Therapist — Therapeutic', category: 'Therapist' },
  { code: '225A00000X', label: 'Music Therapist', category: 'Therapist' },
  { code: '225500000X', label: 'Art Therapist', category: 'Therapist' },

  // --- Pastoral / peer ---
  { code: '101YP1600X', label: 'Counselor — Pastoral', category: 'Counselor' },
  { code: '175T00000X', label: 'Peer Specialist', category: 'Peer Support' },
];
